"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseFormatStr = parseFormatStr;
exports.format = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _constants = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function parseFormatStr(formatStr) {
  var formatName = formatStr.toLowerCase();
  var formatOptions = {};

  if (formatStr.indexOf('(') > -1) {
    var p = formatStr.split('(');
    formatName = p[0].toLowerCase();
    var optStr = p[1].substring(0, p[1].length - 1);

    if (formatName === 'currency') {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    }
  }

  return {
    formatName: formatName,
    formatOptions: formatOptions
  };
}

var format = function format(value, formatStr, language) {
  var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _params$formatParams = params.formatParams,
      formatParams = _params$formatParams === void 0 ? {} : _params$formatParams;

  var _parseFormatStr = parseFormatStr(formatStr),
      formatName = _parseFormatStr.formatName,
      formatOptions = _parseFormatStr.formatOptions;

  if (formatName === 'currency') {
    var maximumFractionDigits = formatParams.maximumFractionDigits,
        minimumFractionDigits = formatParams.minimumFractionDigits,
        currency = formatParams.currency;

    var options = _objectSpread({
      style: 'currency',
      currency: currency || _constants.LANGUAGE_TO_CURRENCY_MAP[language],
      maximumFractionDigits: maximumFractionDigits || _constants.DEFAULT_FRACTION_DIGITS,
      minimumFractionDigits: minimumFractionDigits || _constants.DEFAULT_FRACTION_DIGITS
    }, formatOptions);

    var createFormatter = function createFormatter() {
      try {
        return new Intl.NumberFormat(language, options);
      } catch (_unused) {
        var formatter = new Intl.NumberFormat(language, _objectSpread(_objectSpread({}, options), {}, {
          style: 'decimal',
          currency: undefined
        }));
        return {
          format: function format(v) {
            return "".concat(formatter.format(v), " ").concat(options.currency || '').trim();
          }
        };
      }
    };

    return createFormatter().format(value);
  }

  return value;
};

exports.format = format;